// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';
import { MinimalPrescriptionSetProcedure } from './minimalPrescriptionSetProcedure';
import { MinimalPrescriptionSetMedication } from './minimalPrescriptionSetMedication';

/**
 * Serializer for PrescriptionSet Model structure.
 * @see #/components/schemas/PrescriptionSet - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface PrescriptionSet {
    /**
     * Prescription Set ID
     * @dataFormat uuid
     */
    readonly id: string;
    /**
     * The name of prescription set
     *
     */
    name: string;
    /**
     * Practitioner-ID - Synced with ID of Practitioner in CDR (FHIR)
     * @dataFormat uuid
     */
    last_changed_by: string;
    readonly last_changed_at: string;
    readonly medications: MinimalPrescriptionSetMedication | null;
    readonly procedures: MinimalPrescriptionSetProcedure | null;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for PrescriptionSet
 */
export namespace PrescriptionSet {
    /**
     * PrescriptionSet Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Prescription Set ID
         * @dataFormat uuid
         */
        readonly id: string;
        /**
         * The name of prescription set
         * @type string (`dataFormat` is missing)
         */
        name: string;
        /**
         * Practitioner-ID - Synced with ID of Practitioner in CDR (FHIR)
         * @dataFormat uuid
         */
        lastChangedBy: string;
        @TransformDate() readonly lastChangedAt: Date;
        @Type(() => MinimalPrescriptionSetMedication.Model)
        readonly medications: MinimalPrescriptionSetMedication.Model | null;
        @Type(() => MinimalPrescriptionSetProcedure.Model)
        readonly procedures: MinimalPrescriptionSetProcedure.Model | null;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * PrescriptionSet DTO
     * Transforms PrescriptionSet model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend PrescriptionSet model */
        static toModel(obj: PrescriptionSet): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend PrescriptionSet model */
        static toApi(obj: Model): PrescriptionSet {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as PrescriptionSet;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
